import { render, staticRenderFns } from "./GroupHistory.vue?vue&type=template&id=08912eac"
import script from "./GroupHistory.vue?vue&type=script&lang=js"
export * from "./GroupHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports